import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Flex, Heading } from "@edreamsodigeo/prisma-design-system";
const ManageBookingsBannerHeader = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    gap: "1x_small",
    mt: ["", "1x_big"],
    justifyContent: ["center", "flex-start"]
  }, /*#__PURE__*/React.createElement(Heading, {
    type: ["2", "1"],
    weight: "medium",
    color: "neutral.90"
  }, t("mytripsLogin.managebookings.banner.title")), /*#__PURE__*/React.createElement(Heading, {
    type: ["6", "4"],
    color: "neutral.90",
    weight: "normal"
  }, t("mytripsLogin.managebookings.banner.description")));
};
export default ManageBookingsBannerHeader;